import { setSelectedLanguageAction } from "../store/actions/actionCreators/commonActionCreator";

const setAndGetLocalLang = (languageTerm, language, dispatch) => {
  localStorage.setItem("languageTerm", languageTerm);
  localStorage.setItem("language", language);
  dispatch(setSelectedLanguageAction(languageTerm?.split("-")[0]));
  const savedLanguage = localStorage.getItem("languageTerm");
  return savedLanguage;
};

export default setAndGetLocalLang;
